module.exports = __webpack_public_path__ + "static/media/Building_latest.ced60366.png";